import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Layout = (props) => {
  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div style={{}}>{props.children}</div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Layout;
